import Container from '@ui/container/container';
import Switch from '@ui/switch/switch';
import Text from '@ui/text/text/text';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { updateProjectSettings } from '@/store/slices/project';
import { getWorkingProject } from '@/store/slices/project/selectors';

const MicrosoftEcdnCard = () => {
  const dispatch = useAppDispatch();
  const workingProject = useAppSelector(getWorkingProject);

  const enabled = !!workingProject?.settings?.microsoft_ecdn_enabled;

  const toggleMicrosoftEcdn = (_value: string, on: boolean) => {
    if (!workingProject) return;
    dispatch(
      updateProjectSettings({
        event_uuid: workingProject.uuid,
        settings: { ...workingProject.settings, microsoft_ecdn_enabled: on },
      })
    );
  };

  return (
    <Container
      className="flex flex-column"
      background="var(--gray-900)"
      hoverBackground="var(--gray-800)"
      borderRadius="var(--card-radius)"
      padding="16px"
      height="202px"
      opacity={enabled ? 1 : 0.8}
    >
      <Container className="flex ai-center jc-space-between" width="100%" margin="0 0 4px 0">
        <Icon name={ICONS.MICROSOFT} size={32} color="default" />
        <Switch value="microsoft_ecdn" on={enabled} onClick={toggleMicrosoftEcdn} />
      </Container>

      <Container className="flex flex-column" width="100%" margin="auto 0 16px 0">
        <Text className="S1" tag="p">
          Microsoft eCDN
        </Text>
        <Text tag="span" color="var(--Grayscale-300-grey, #BFBBCF)">
          eCDN Integration
        </Text>
      </Container>
    </Container>
  );
};

export default MicrosoftEcdnCard;
